require('./src/styles/init.scss');
require('./static/css/prismjs/theme.min.css');
